<template>
  <div class="el-main" v-loading.fullscreen.lock="fullscreenLoading" :element-loading-text="loadingText">

    <div class="card" v-show="currentCardId == 'long_reason'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>志望動機</h2>
          <p>志望動機を書くときはAI文章生成を活用しよう</p>
        </div>

        <div class="add-item button-block" v-if="$globalVar.in_app_payments">
          <!--<el-button @click="$refs.chatBot.open()" id="prime-reasonai-btn" type="success">最新のAIを使う</el-button>-->
          <button @click="openReasonLongChat()" id="prime-reasonai-btn" type="success" class="primary-button">
            <span>AIで文章作成</span>
          </button>
        </div>

        <!-- YagiChatBotコンポーネント -->
        <yagi-chat-bot ref="chatBot" modal-name="shiboudoukisho-ai" :questions="aiQuestions" v-model="formatData"
          :auto-skip-filled="true" :show-usage-count="true" :usage-count="aiUsageCount"
          :max-usage-count="aiMaxUsageCount" :usage-count-label="$globalVar.isYagiPrime ? '1日利用回数' : '利用回数'"
          chat-type="shiboudoukisho" @complete="generateAiMypr">

          <!-- 結果表示エリア -->
          <template slot="result" slot-scope="{ result, close }">
            <div
              style="background: white; border-radius: 8px; padding: 20px; margin-bottom: 15px; border: 1px solid #ddd;">
              <div style="font-weight: bold; margin-bottom: 15px; color: #27ae60; font-size: 1.1rem;">
                AIからの提案
              </div>
              <div style="line-height: 1.8; color: #333; margin-bottom: 20px;" v-html="result"></div>

              <!-- この文章を使うボタン -->
              <div style="text-align: center;">
                <el-button type="success" size="medium" @click="applyAiResult(result, close)"
                  style="width: 100%; font-size: 1rem; padding: 12px 0;">
                  この文章を使う
                </el-button>
              </div>
            </div>

            <div v-if="!$globalVar.isYagiPrime" class="text-right" style="margin-top: 10px;">
              全文を表示する場合は／<br>
              <el-button @click="goYagiprimeRegister" id="prime-reasonai-register-btn" v-if="$globalVar.in_app_payments"
                style="color: #fff; background-color: #e3165c; border-color: #e3165c;">
                ヤギプライム会員になる
              </el-button>
            </div>
          </template>
        </yagi-chat-bot>

        <div class="card-content">
          <el-input type="textarea" v-model="formatData.longreason"
            :autosize="{ minRows: textareaMinRows, maxRows: 15 }"></el-input>
          <div class="attention-limit character" v-if="previewErrors.longreason">
            <i class="el-icon-warning"></i> 入力可能な文字数をオーバーしています。文章を短くするか、入力欄の大きい別の履歴書を選んでください。
          </div>

        </div>
      </div>
    </div>

    <!--作成日-->
    <div class="card" v-show="currentCardId == 'create-date'">
      <div class="overflow-scroll-y">
        <div class="card-header">
          <h2>志望動機書の作成日を入力</h2>
          <p>実際に書類を持参する日、または郵送する日を選びましょう</p>
        </div>
        <div class="card-content">
          <div class="edit-form-list">
            <div class="create-date-action">
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getToday())"
                  @click="formatData.createDate = $formLib.getToday()">今日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-button class="button-block"
                  :disabled="$formLib.dateWithoutTime(formatData.createDate) == $formLib.dateWithoutTime($formLib.getTommorow())"
                  @click="formatData.createDate = $formLib.getTommorow()">明日の日付を入力</el-button>
              </div>
              <div class="action-item">
                <el-date-picker v-model="formatData.createDate" type="date" :clearable="false" placeholder="選択してください"
                  :format="'yyyy年M月d日'" ref="create_date">
                </el-date-picker>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--確認-->
    <div class="card" v-show="currentCardId == 'confirm'">
      <div class="overflow-scroll-y">
        <div class="card-header" style="max-width: 40rem;margin: 2rem auto -3rem;">
          <h2>作成した志望動機書を確認</h2>
        </div>
      </div>
    </div>

    <!--完了ページ-->
    <div class="card" v-show="currentCardId == 'output'" v-if="getMode != 'production1'">
      <download-item :formatId="formatId" :isSendYagiPostEnabled="isSendYagiPostEnabled"
        :isSendYagiEmailEnabled="isSendYagiEmailEnabled" :mailPdfEnabled="mailPdfEnabled"
        :downloadPdfEnabled="downloadPdfEnabled" :downloadActiveCollapses="downloadActiveCollapses">
      </download-item>
    </div>

  </div>
</template>
<style lang="scss" scoped>
.edit-form-list {
  .edit-form-item {
    margin-bottom: 30px;

    .title {
      font-size: 1rem;
      font-weight: bold;
      margin-bottom: 8px;
      color: #333;
    }

    .body {
      font-size: 0.85rem;
      color: #666;
      margin-bottom: 8px;
      line-height: 1.5;
    }
  }
}

// チャットモーダルのスタイル
.chat-modal {
  ::v-deep .v--modal-box {
    border-radius: 12px;
    overflow: hidden;
    padding: 0 !important;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  }

  ::v-deep .v--modal {
    background: rgba(0, 0, 0, 0.5) !important;
  }
}

.button-block {

  .primary-button {
    position: relative;
    background: #FF8C00;
    color: rgb(255, 255, 255);
    border: none;
    margin-right: 10px;
    padding: 12px 20px;
    border-radius: 4px;

    &::after {
      position: absolute;
      content: "✨";
      font-size: 20px;
      top: -5px;
      right: -7px;
    }

  }

  @media screen and (max-width: 768px) {
    margin-right: 0;
    padding: 0;
    justify-content: center;
  }
}

// ヘッダー
.chat-header {
  background: linear-gradient(135deg, #1a5f4f 0%, #2d8b6f 100%);
  color: white;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .chat-header-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .chat-avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .chat-header-text {
    .chat-title {
      font-weight: bold;
      font-size: 1rem;
      margin-bottom: 2px;
    }

    .chat-subtitle {
      font-size: 0.75rem;
      opacity: 0.9;
    }
  }

  .close-btn {
    background: transparent;
    border: none;
    color: white;
    font-size: 1.5rem;
    cursor: pointer;
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;

    &:hover {
      opacity: 0.8;
    }

    i {
      font-size: 1.5rem;
    }
  }
}

// 日付表示
.chat-date {
  text-align: center;
  color: #999;
  font-size: 0.75rem;
  padding: 15px 0 10px;
  background: #f8f8f8;
}

// チャット形式のスタイル
.chat-container {
  display: flex;
  flex-direction: column;
  height: 550px;
  max-height: 75vh;
  background: #f8f8f8;
}

.chat-messages {
  flex: 1;
  overflow-y: auto;
  padding: 15px 20px;
  background: #f8f8f8;
}

.chat-message {
  margin-bottom: 20px;
  animation: fadeIn 0.3s ease-in;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.chat-question {
  display: flex;
  justify-content: flex-start;
}

.chat-answer {
  display: flex;
  justify-content: flex-end;
}

.chat-system {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.question-bubble {
  background: #e8f5e9;
  padding: 14px 18px;
  border-radius: 18px;
  border-top-left-radius: 4px;
  max-width: 85%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);

  .question-text {
    font-weight: normal;
    color: #333;
    margin-bottom: 6px;
    line-height: 1.5;
  }

  .question-description {
    font-size: 0.8rem;
    color: #666;
    line-height: 1.4;
    margin-top: 6px;
  }
}

.answer-bubble {
  background: white;
  color: #333;
  padding: 14px 18px;
  border-radius: 18px;
  border-top-right-radius: 4px;
  max-width: 85%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  border: 1px solid #e0e0e0;

  .answer-text {
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.5;
  }
}

.system-bubble {
  background: #fff3cd;
  color: #856404;
  padding: 12px 16px;
  border-radius: 12px;
  max-width: 90%;
  border: 1px solid #ffeaa7;

  .system-content {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }

  .system-icon {
    font-size: 1.2rem;
    flex-shrink: 0;
    color: #27ae60;
  }

  .system-text {
    font-weight: bold;
    font-size: 0.9rem;
  }

  .skipped-list {
    margin-top: 6px;
    font-size: 0.8rem;
    color: #6c757d;
    font-weight: normal;

    .skipped-item {
      padding: 2px 0;
    }
  }

  .edit-skipped-btn-wrapper {
    margin-top: 10px;
    text-align: center;

    .el-button {
      background-color: #2d8b6f;
      border-color: #2d8b6f;
      color: white;

      &:hover {
        background-color: #1a5f4f;
        border-color: #1a5f4f;
      }
    }
  }
}

.chat-input-area {
  background: white;
  padding: 15px 20px;
  border-top: 1px solid #e0e0e0;

  .input-container {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;

    .add-button {
      background: none;
      border: none;
      color: #27ae60;
      font-size: 1.8rem;
      cursor: pointer;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: transform 0.2s;

      &:hover {
        transform: scale(1.1);
      }

      &:active {
        transform: scale(0.95);
      }
    }

    .chat-input-field {
      flex: 1;
      border: 1px solid #ddd;
      border-radius: 20px;
      padding: 10px 16px;
      font-size: 0.9rem;
      outline: none;
      transition: border-color 0.2s;

      &:focus {
        border-color: #27ae60;
      }

      &::placeholder {
        color: #999;
      }
    }

    .send-button {
      background: #27ae60;
      border: none;
      color: white;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 1.2rem;
      transition: background 0.2s, transform 0.2s;

      &:hover {
        background: #229954;
        transform: scale(1.05);
      }

      &:active {
        transform: scale(0.95);
      }
    }
  }

  .progress-info {
    display: flex;
    justify-content: space-between;
    font-size: 0.75rem;
    color: #999;
    padding: 0 5px;

    .progress-text {
      font-weight: 500;
    }

    .usage-text {
      color: #666;
    }
  }
}

.yagitaku {
  line-height: 25px;
  padding: 15px 0;
  font-weight: bold;
}

.yagitaku_recommend {
  color: #fff;
  background: #E3165C;
  padding: 5px 10px;
  margin-right: 5px;
  border-radius: 50px;
}

.yagitaku_link {
  color: #E3165C;
  border-bottom: 1px solid #E3165C;
}

.create-date_bnr {
  margin: 15px 0;
}

.addition {
  font-size: .75rem;
  margin: .5rem 0;
}

* {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

img {
  width: 100%;
  vertical-align: bottom;
}

.next_bnr {
  font-size: 1rem;
  color: #004d40;
  text-align: center;
  padding: 1.2rem;
}

.bnr_container {
  display: flex;
  flex-wrap: wrap;
  margin: calc(-30px / 2);
  padding: 30px;
}

.bnr_itemWrapper {
  width: calc(100% / 2 - 30px);
  margin: calc(30px / 2);
}

.bnr_item {
  text-align: center;
}

.bnr_item img {
  border-radius: 10px 10px 0 0;
}

.bnr_txt {
  padding: 15px;
  background: #EFF8F8;
  border-radius: 0 0 10px 10px;
}

.txt {
  border-radius: 10px;
}

.bnr_txt p {
  font-size: 0.8rem;
  font-weight: bold;

}

.bnr_txt h3 {
  color: #E3165C;
  font-size: 1.1rem;
  font-weight: bold;
}

.bnr_txt span {
  font-size: 0.8rem;
}

.create-date_txt {
  border-radius: 10px;
}

.bnr_note {
  font-size: 0.8rem;
}

.card-header h1 {
  padding-bottom: 1.5rem;
}

.card-header h2 {
  padding-bottom: 1.5rem;
}

/* タブレット　2カラム */
@media screen and (max-width: 1024px) {
  .bnr_itemWrapper {
    width: calc(100% / 2 - 30px);
  }
}

/* スマホ 1カラム*/
@media screen and (max-width: 599px) {
  .bnr_itemWrapper {
    width: calc(100% / 1 - 30px);
  }
}
</style>

<script>
// import HistoryItem from './RirekishoParts/HistoryItem'
import HistoryItemSkill from './ShokurekishoParts/HistoryItemSkill'
import HistoryItemJob from './ShokurekishoParts/HistoryItemJob'
// import AutoEducationalBackgrounds from './RirekishoParts/AutoEducationalBackgrounds'
// import AutoJobHistories from './RirekishoParts/AutoJobHistories'
import LocalDataMixin from '@/mixins/local-data-mixin'
import LoginForms from '@/components/LoginSpecialForms'
import DownloadItem from './CommonParts/DownloadItem'
import YagiChatBot from '@/components/common/YagiChatBot'

const uuidv4 = function () {
  const cryptoObj = window.crypto || window.msCrypto
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
    (c ^ cryptoObj.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
  )
}
const SkillHistoryData = function (columns) {
  this.skillname = columns.skillname || ''
  this.years = Number(columns.years) || ''
  this.description = columns.description || ''
  this.uuid = uuidv4()
}
// const SkillHistoryData2 = class sh {
//   constructor (columns) {
//     this.skillname = columns.skillname || ''
//     this.years = Number(columns.years) || ''
//     this.description = columns.description || ''
//     this.uuid = uuidv4()
//   }
//   run () {
//     return (this.uuid)
//   }
// }
const JobHistoryData = function (columns) {
  this.companyName = columns.companyName || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.isContinuing = columns.isContinuing || false
  this.capitalStock = columns.capitalStock || ''
  this.numberOfEmployees = columns.numberOfEmployees || ''
  this.businessArea = columns.businessArea || ''
  this.projects = columns.projects || []
  this.uuid = uuidv4()
}
const ProjectHistoryData = function (columns) {
  this.projectTitle = columns.projectTitle || ''
  this.startYear = Number(columns.startYear) || ''
  this.startMonth = Number(columns.startMonth) || ''
  this.endYear = Number(columns.endYear) || ''
  this.endMonth = Number(columns.endMonth) || ''
  this.contentsOfProject = columns.contentsOfProject || ''
  this.envAndScale = columns.envAndScale || ''
  this.position = columns.position || ''
  this.uuid = uuidv4()
}

export default {
  name: 'LetterEdit',
  props: {
    basicData: {
      type: Object,
      require: true
    },
    formatId: {
      type: String
    },
    previewFormat: {
      type: Object,
      require: true
    },
    currentCardId: {
      type: String
    },
    exampleSentences: {
      type: Object
    }
  },
  mixins: [LocalDataMixin],
  components: {
    'history-item': HistoryItemJob,
    'download-item': DownloadItem,
    'history-item-skill': HistoryItemSkill,
    // 'auto-job-histories': AutoJobHistories,
    'login-forms': LoginForms,
    'yagi-chat-bot': YagiChatBot
  },
  data: function () {
    return {
      saveName: 'shiboudoukisho',
      saveOtherName: 'rirekisho',
      activeName: '1',
      formatData: {
        createDate: null,
        introSummary: '',
        entrySummary: '',
        resumeSummary: '',
        occupation: 'others',
        jobSummary: '',
        experienceAndKnowledge: '',
        skillsToUse: [],
        jobHistories: [],
        licenseHistories: [],
        prMessage: '',
        ai_education_detail: '',
        ai_licenses_detail: '',
        ai_job_detail: '',
        ai_company_url: '',
        ai_company_name: '',
        ai_company_industry: '',
        ai_company_job: '',
        ai_company_values: '',
        ai_future_vision: '',
        ai_strength_episode: ''
      },
      isWeekEndFlag: true,
      staff_name_Error: false,
      activeHistoryItem: '',
      descriptionMaxLength: 80,
      mailPdfEnabled: true,
      downloadPdfEnabled: true,
      isSendYagiPostEnabled: true,
      isSendYagiEmailEnabled: true,
      eprintPdfEnabled: true,
      textareaMinRows: 5,
      downloadActiveCollapses: ['postcard'],
      occupationOptions: [
        {
          value: 'engineer',
          label: 'エンジニア'
        },
        {
          value: 'sales',
          label: '営業'
        },
        {
          value: 'backoffice',
          label: '事務'
        },
        {
          value: 'others',
          label: 'その他'
        }
      ],
      fullscreenLoading: false,
      loadingText: 'AIがあなたに最適な志望動機書を生成しています',
      aiResultView: false,
      aiResultMyprResult: '',
      aiUsageCount: 0,
      aiMaxUsageCount: 1,
      // チャット形式用
      currentQuestionIndex: 0,
      chatMessages: [],
      currentAnswer: '',
      isComposing: false, // 日本語入力中かどうか
      aiQuestions: [
        {
          id: 'education',
          question: '最終学歴の詳細を教えてください',
          description: '学校名、学部・学科、専攻、卒業年を記入してください',
          placeholder: '例）〇〇大学 経済学部 経営学科 2020年3月卒業',
          field: 'ai_education_detail'
        },
        {
          id: 'licenses',
          question: '保有資格の詳細を教えてください',
          description: '資格名、取得年、レベル・難易度を記入してください（複数ある場合は全て）',
          placeholder: '例）TOEIC 850点（2021年取得）、日商簿記2級（2019年取得）',
          field: 'ai_licenses_detail',
          allowNone: true
        },
        {
          id: 'job',
          question: '最終職歴の詳細を教えてください',
          description: '企業名、所属部署、職種、在籍期間、主な業務内容と成果（できれば数値付き）を記入してください',
          placeholder: '例）株式会社〇〇 営業部 法人営業 2020年4月〜2024年3月（4年間） 新規顧客開拓を担当し、年間売上目標120%達成。顧客満足度向上施策を提案し、リピート率を30%改善。',
          field: 'ai_job_detail'
        },
        {
          id: 'company_url',
          question: '応募先企業のURLを教えてください',
          description: '企業サイトのURLがあれば、企業情報を自動取得できます（任意）',
          placeholder: '例）https://www.example.co.jp/company/',
          field: 'ai_company_url',
          type: 'url',
          skippable: true,
          autoFillFields: {
            company_name: 'ai_company_name',
            industry: 'ai_company_industry',
            job: 'ai_company_job',
            values: 'ai_company_values'
          }
        },
        {
          id: 'company_name',
          question: '志望先会社名を教えてください',
          description: '',
          placeholder: '例）株式会社Yagish',
          field: 'ai_company_name',
          autoSkipIfFilled: true
        },
        {
          id: 'company_industry',
          question: '志望先会社の業種を教えてください',
          description: '',
          placeholder: '例）IT・情報通信、製造、サービス、金融など',
          field: 'ai_company_industry',
          autoSkipIfFilled: true
        },
        {
          id: 'company_job',
          question: '志望先会社の職種を教えてください',
          description: '',
          placeholder: '例）営業、企画、開発、事務、マーケティングなど',
          field: 'ai_company_job',
          autoSkipIfFilled: true
        },
        {
          id: 'company_values',
          question: '企業の特徴・価値観を教えてください（分かれば）',
          description: '企業理念、強み、求める人材像など',
          placeholder: '例）顧客第一主義、イノベーション重視、チャレンジ精神を大切にする企業文化',
          field: 'ai_company_values',
          autoSkipIfFilled: true
        },
        {
          id: 'future_vision',
          question: '将来のビジョン・入社後の貢献像を教えてください',
          description: 'キーワードや箇条書きで簡単に入力してください',
          placeholder: '例）・3年後：チームリーダー ・5年後：新規事業立ち上げ ・営業経験を活かして売上貢献',
          field: 'ai_future_vision'
        },
        {
          id: 'strength',
          question: 'あなたの強みを教えてください（任意）',
          description: 'キーワードで入力してください',
          placeholder: '例）・データ分析力 ・チームマネジメント経験 ・顧客折衝スキル',
          field: 'ai_strength_episode'
        }
      ]
    }
  },
  computed: {
    previewErrors: function () {
      if (!this.previewFormat || !this.previewFormat.errorMessages) return {}
      return this.previewFormat.errorMessages
    },
    optionItems: function () {
      if (!this.previewFormat || !this.previewFormat.optionItems) return {}
      return this.previewFormat.optionItems
    },
    isMynabi: function () {
      return (this.$yagi.isFromMynabi === 1)
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  watch: {
    formatData: function () {
      console.log(this.formatData.staff_name)
      if (this.formatData.jobHistories.length === 0) {
        // this.addJobHistory()
        // this.addProjectHistory(0)
        // this.createProjectHistoryItem()
        // console.log('asdf')
      }
    },
    'formatData.staff_name': function (newValue) {
      console.log(newValue)
      if (newValue.indexOf('さま') >= 0 || newValue.indexOf('様') >= 0) {
        this.staff_name_Error = true
      } else {
        this.staff_name_Error = false
      }
    },
    'formatData.createDate': function (newValue) {
      this.formatData.writeDate = this.$formLib.dateFormat(newValue, 'yyyy年 m月 d日')
    }
  },
  methods: {
    filtered: function (obj) {
      const selectedOccupation = this.formatData.occupation
      return obj.filter(function (item) {
        return item.type === selectedOccupation
      })
    },
    setJobHistories: function (historyList) {
      // 先頭から追加
      for (const key in historyList) {
        const item = historyList[key]
        this.addJobHistory(null, {
          year: item.year,
          month: item.month,
          description: item.desc
        })
      }
    },
    resetJobHistories: function () {
      this.formatData.jobHistories = []
    },
    createJobHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new JobHistoryData(columns)
    },
    createProjectHistoryItem: function (columns) {
      if (!columns) columns = {}
      return new ProjectHistoryData(columns)
    },
    historySort: function (a, b) {
      let aYear = Number(a.year)
      let aMonth = Number(a.month)
      let bYear = Number(b.year)
      let bMonth = Number(b.month)
      if (aYear === bYear && aMonth === bMonth) {
        return 0
      }
      // 空欄は一番下に
      if (!aYear) aYear = 9999
      if (!aMonth) aMonth = 99
      if (!bYear) bYear = 9999
      if (!bMonth) bMonth = 99
      if (aYear > bYear) {
        return 1
      } else if (aYear < bYear) {
        return -1
      }
      if (aMonth > bMonth) {
        return 1
      } else if (aMonth < bMonth) {
        return -1
      }
      console.log('historySort failed')
      return 0
    },
    sortHistory: function (historyList) {
      // copy and sort
      return historyList.slice().sort(this.historySort)
    },
    checklog: function () {
      console.log(this.formatData)
    },
    addSkillHistory: function (index, columns) {
      const historyList = this.formatData.skillsToUse
      if (!columns) columns = {}
      const newHistoryItem = new SkillHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addJobHistory: function (index, columns) {
      const historyList = this.formatData.jobHistories
      if (!columns) columns = {}
      const newHistoryItem = new JobHistoryData(columns)
      if (typeof index === 'number') {
        historyList.splice(index, 0, newHistoryItem)
      } else {
        historyList.push(newHistoryItem)
      }
    },
    addProjectHistory: function (index, columns) {
      // const targetItem = this.formatData.jobHistories.find((item) => {
      //   return (item.uuid === this.activeHistoryItem)
      // })
      const targetItem = this.formatData.jobHistories[index]
      if (!columns) columns = {}
      const newHistoryItem = new ProjectHistoryData(columns)
      targetItem.projects.push(newHistoryItem)
    },
    moveSkillHistory: function (params) {
      this.moveHistory(this.formatData.skillsToUse, params)
    },
    moveJobHistory: function (params) {
      this.moveHistory(this.formatData.jobHistories, params)
    },
    moveJobHistoryDetail: function (params, parentIndex) {
      this.moveHistory(this.formatData.jobHistories[parentIndex].projects, params)
    },
    sendQuickmailLP: function () {
      location.href = '/quickmailhelp'
    },
    moveHistory: function (historyList, params) {
      const fromIndex = params.index
      const to = params.to
      if (fromIndex === 0 && to === 'up') {
        console.log('first item skip')
        return
      }
      if (fromIndex + 1 === historyList.length && to === 'down') {
        console.log('last item skip')
        return
      }
      if (to === 'up') {
        historyList.splice(fromIndex - 1, 2, historyList[fromIndex], historyList[fromIndex - 1])
      } else if (to === 'down') {
        historyList.splice(fromIndex, 2, historyList[fromIndex + 1], historyList[fromIndex])
      } else {
        console.log('param "to" must be "up" or "down"')
      }
    },
    deleteSkillHistory: function (index) {
      this.formatData.skillsToUse.splice(index, 1)
    },
    deleteJobHistory: function (index) {
      this.formatData.jobHistories.splice(index, 1)
    },
    deleteHistoryDetail: function (index, index2) {
      console.log(index, index2)
      this.formatData.jobHistories[index].projects.splice(index2, 1)
    },
    activateHistoryItem: function (id) {
      this.activeHistoryItem = id
    },
    deactivateHistoryItem: function () {
      this.activeHistoryItem = ''
    },
    dataChanged: function () {
      console.error('dataChanged')
      this.mailPdfEnabled = true
      this.downloadPdfEnabled = true
    },
    showAiMyprDialog () {
      if (!this.$firebase.isAuthenticated) {
        this.$eventHub.$emit('open-login-dialog')
        return
      }
      if (!this.$globalVar.isYagiPrime) {
        this.openReasonLongPaymentDialog()
        return
      }

      // チャット初期化
      this.currentQuestionIndex = 0
      this.chatMessages = []
      this.currentAnswer = ''
      this.aiResultView = false

      // 履歴書データから自動入力
      this.autoFillFromRirekisho()

      // 既に入力済みの質問をスキップして最初の未入力質問を見つける
      this.skipFilledQuestions()

      this.$modal.show('ai-mypr-dialog')
      this.$nextTick(() => {
        this.fetchAiUsageCount()
      })
    },
    skipFilledQuestions () {
      const app = this
      let skippedCount = 0
      const skippedQuestions = []
      const skippedIndices = []

      // 既に入力済みの質問をチェック
      while (app.currentQuestionIndex < app.aiQuestions.length) {
        const question = app.aiQuestions[app.currentQuestionIndex]
        const value = app.formatData[question.field]

        if (value && value.trim()) {
          // 入力済みの場合、スキップメッセージを追加
          skippedQuestions.push(question.question)
          skippedIndices.push(app.currentQuestionIndex)
          app.currentQuestionIndex++
          skippedCount++
        } else {
          // 未入力の質問が見つかったら停止
          break
        }
      }

      // スキップした質問がある場合、メッセージを表示
      if (skippedCount > 0) {
        app.chatMessages.push({
          type: 'system',
          text: `履歴書から${skippedCount}件の情報を取得しました`,
          skippedQuestions,
          skippedIndices
        })
      }

      // 次の質問を追加（全て入力済みの場合は何もしない）
      if (app.currentQuestionIndex < app.aiQuestions.length) {
        app.addQuestionToChat(app.currentQuestionIndex)
        // 既に入力済みの値があれば設定
        const currentQuestion = app.aiQuestions[app.currentQuestionIndex]
        app.currentAnswer = app.formatData[currentQuestion.field] || ''
      }

      // チャットを最下部にスクロール
      this.$nextTick(() => {
        if (this.$refs.chatMessages) {
          this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight
        }
      })
    },
    addQuestionToChat (index) {
      if (index >= this.aiQuestions.length) {
        return
      }
      const question = this.aiQuestions[index]
      this.chatMessages.push({
        type: 'question',
        text: question.question,
        description: question.description,
        placeholder: question.placeholder,
        questionId: question.id
      })

      // チャットを最下部にスクロール
      this.$nextTick(() => {
        if (this.$refs.chatMessages) {
          this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight
        }
      })
    },
    submitAnswer () {
      const currentQuestion = this.aiQuestions[this.currentQuestionIndex]

      // 回答を保存
      this.formatData[currentQuestion.field] = this.currentAnswer

      // チャットに回答を追加
      if (this.currentAnswer.trim()) {
        this.chatMessages.push({
          type: 'answer',
          text: this.currentAnswer
        })
      }

      // 次の質問へ
      this.currentQuestionIndex++
      this.currentAnswer = ''

      if (this.currentQuestionIndex < this.aiQuestions.length) {
        // 次の質問を追加
        this.addQuestionToChat(this.currentQuestionIndex)
        // 既に入力済みの値があれば設定
        const nextQuestion = this.aiQuestions[this.currentQuestionIndex]
        this.currentAnswer = this.formatData[nextQuestion.field] || ''
      } else {
        // 全ての質問が終了したらAI生成を実行
        this.getAIMypr()
      }

      // チャットを最下部にスクロール
      this.$nextTick(() => {
        if (this.$refs.chatMessages) {
          this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight
        }
      })
    },
    skipQuestion () {
      this.currentAnswer = ''
      this.submitAnswer()
    },
    editSkippedQuestions (skippedIndices) {
      // スキップした質問の最初に戻る
      if (skippedIndices && skippedIndices.length > 0) {
        // 現在の回答をクリア
        this.currentAnswer = ''

        // 最初のスキップした質問のインデックスに戻る
        this.currentQuestionIndex = skippedIndices[0]

        // チャットメッセージをクリアして、最初から再構築
        this.chatMessages = []

        // システムメッセージを削除して、最初のスキップした質問から開始
        this.addQuestionToChat(this.currentQuestionIndex)

        // 既に入力済みの値があれば設定
        const currentQuestion = this.aiQuestions[this.currentQuestionIndex]
        this.currentAnswer = this.formatData[currentQuestion.field] || ''
      }
    },
    handleEnterKey (event) {
      // 日本語入力中（変換中）の場合は送信しない
      if (this.isComposing) {
        return
      }
      // Enterキーで送信
      event.preventDefault()
      this.submitAnswer()
    },
    getCurrentDate () {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}.${month}.${day}`
    },
    openReasonLongChat () {
      this.fetchAiUsageCount().finally(() => {
        if (this.$refs.chatBot) {
          this.$refs.chatBot.open()
        }
      })
    },
    fetchAiUsageCount () {
      const app = this
      if (!app.$firebase || !app.$firebase.isAuthenticated) {
        app.aiUsageCount = 0
        app.aiMaxUsageCount = 1
        return Promise.resolve()
      }
      const formData = new FormData()
      formData.append('uuid', app.$firebase.user.uid)
      formData.append('category_type', 'reason_long')

      return app.$axios
        .post(app.$varuna.endPoints.getAiUsageCount, formData)
        .then(function (response) {
          if (response.data.success) {
            app.aiUsageCount = response.data.usage_count || 0
            // ヤギプライム会員の場合は最大10回、それ以外は1回
            app.aiMaxUsageCount = app.$globalVar.isYagiPrime ? 10 : 1
          }
        })
        .catch(function (error) {
          console.error('AI利用回数の取得に失敗しました', error)
        })
    },
    closeAiMyprDialog () {
      this.$modal.hide('ai-mypr-dialog')
      this.aiResultView = false
    },
    openReasonLongPaymentDialog () {
      const routeId = this.$cookies.get('_YAGISH_YAGIPRIME_ROUTE_ID') || ''
      this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#reason_long', null, null, 'yagish.jp')
      this.$cookies.set('_YAGISH_YAGIPRIME_ROUTE_ID', routeId + '#reason_long', null, null, 'localhost')
      this.$eventHub.$emit('show-yagiprime-payment-dialog', 'reason_long')
    },
    goYagiprimeRegister () {
      this.openReasonLongPaymentDialog()
    },
    autoFillFromRirekisho () {
      const app = this

      // 履歴書データを取得
      this.$getItem('format_rirekisho', function (err, rirekishoData) {
        if (err || !rirekishoData) {
          // 履歴書データがない場合は何もしない（エラーメッセージも表示しない）
          return
        }

        // Q.1 最終学歴の詳細を自動入力
        if (rirekishoData.educationalHistories && rirekishoData.educationalHistories.length > 0) {
          // 最後の学歴（卒業）を取得
          const educations = rirekishoData.educationalHistories.filter(e => e.description && e.description.includes('卒業'))
          if (educations.length > 0) {
            const lastEducation = educations[educations.length - 1]
            app.formatData.ai_education_detail = `${lastEducation.description} (${lastEducation.year}年${lastEducation.month}月)`
          }
        }

        // Q.2 保有資格の詳細を自動入力
        if (rirekishoData.licenseHistories && rirekishoData.licenseHistories.length > 0) {
          const licenses = rirekishoData.licenseHistories
            .filter(l => l.description)
            .map(l => {
              if (l.year && l.month) {
                return `${l.description} (${l.year}年${l.month}月取得)`
              }
              return l.description
            })
            .join('、')
          app.formatData.ai_licenses_detail = licenses
        }

        // Q.3 最終職歴の詳細を自動入力（職務経歴書データも確認）
        app.$getItem('format_shokumukeirekisho', function (err, shokurekishoData) {
          if (!err && shokurekishoData) {
            // 職務経歴書の職務要約を使用
            if (shokurekishoData.jobSummary) {
              app.formatData.ai_job_detail = shokurekishoData.jobSummary
            } else if (shokurekishoData.jobHistories && shokurekishoData.jobHistories.length > 0) {
              // 職歴がある場合は最新の職歴を使用
              const lastJob = shokurekishoData.jobHistories[shokurekishoData.jobHistories.length - 1]
              let jobDetail = ''
              if (lastJob.companyName) {
                jobDetail += lastJob.companyName
              }
              if (lastJob.startYear && lastJob.startMonth) {
                jobDetail += ` ${lastJob.startYear}年${lastJob.startMonth}月〜`
                if (lastJob.isContinuing) {
                  jobDetail += '現在'
                } else if (lastJob.endYear && lastJob.endMonth) {
                  jobDetail += `${lastJob.endYear}年${lastJob.endMonth}月`
                }
              }
              if (lastJob.projects && lastJob.projects.length > 0) {
                const project = lastJob.projects[0]
                if (project.contentsOfProject) {
                  jobDetail += `\n${project.contentsOfProject}`
                }
              }
              app.formatData.ai_job_detail = jobDetail
            }
          } else if (rirekishoData.jobHistories && rirekishoData.jobHistories.length > 0) {
            // 履歴書の職歴を使用
            const jobs = rirekishoData.jobHistories
              .filter(j => j.description)
              .map(j => {
                if (j.year && j.month) {
                  return `${j.year}年${j.month}月 ${j.description}`
                }
                return j.description
              })
              .join('\n')
            app.formatData.ai_job_detail = jobs
          }
        })
      })
    },
    // YagiChatBotコンポーネントから呼ばれるメソッド
    generateAiMypr (data) {
      // データは既にformatDataに保存されているので、getAIMyprを呼び出すだけ
      this.getAIMypr()
    },
    // AI生成結果を適用するメソッド
    applyAiResult (result, close) {
      // <br>タグを改行に変換して設定
      const cleanText = result.replace(/<br>/ig, '\n')

      // Vue.setを使ってリアクティブに更新
      this.$set(this.formatData, 'longreason', cleanText)

      // 次のティックで確実に更新されてからモーダルを閉じる
      this.$nextTick(() => {
        close()
      })
    },
    getAIMypr () {
      const app = this

      // 認証チェック
      if (!app.$firebase.isAuthenticated) {
        app.$eventHub.$emit('open-login-dialog')
        return
      }

      // 非プライムは無料1回まで実行可。2回目以降は課金導線へ。
      if (!app.$globalVar.isYagiPrime && app.aiUsageCount >= 1) {
        app.openReasonLongPaymentDialog()
        return
      }

      app.fullscreenLoading = true
      const formData = new FormData()

      if (app.$firebase && app.$firebase.isAuthenticated) {
        formData.append('uuid', app.$firebase.user.uid)
      }
      formData.append('education_detail', app.formatData.ai_education_detail || '')
      formData.append('licenses_detail', app.formatData.ai_licenses_detail || '')
      formData.append('job_detail', app.formatData.ai_job_detail || '')
      formData.append('company_name', app.formatData.ai_company_name || '')
      formData.append('company_industry', app.formatData.ai_company_industry || '')
      formData.append('company_job', app.formatData.ai_company_job || '')
      formData.append('company_values', app.formatData.ai_company_values || '')
      formData.append('future_vision', app.formatData.ai_future_vision || '')
      formData.append('strength_episode', app.formatData.ai_strength_episode || '')
      formData.append('reason', app.formatData.longreason || '')

      this.$axios
        .post(this.$varuna.endPoints.aiIntroduceReasonLong, formData, { timeout: 120000 })
        .then(function (response) {
          if (response.data.success) {
            app.aiResultMyprResult = response.data.message
            // YagiChatBotコンポーネントに結果を表示
            if (app.$refs.chatBot) {
              app.$refs.chatBot.showResultView(response.data.message)
            }
            app.$message({
              message: '取得しました',
              type: 'success'
            })
            // 利用回数を再取得
            app.fetchAiUsageCount()
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
        })
        .catch(function (error) {
          const errorMessage = error.response && error.response.data && error.response.data.message
          if (errorMessage === 'AIの使用回数が上限に達しました。') {
            app.openReasonLongPaymentDialog()
          } else if (errorMessage) {
            app.$message({
              message: errorMessage,
              type: 'error'
            })
          } else {
            app.$message({
              message: '失敗しました',
              type: 'error'
            })
          }
          // エラー時も利用回数を再取得
          app.fetchAiUsageCount()
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  created: function () {
    const nowdate = new Date()
    const date1 = new Date('2023/05/27 00:00:00')
    const date2 = new Date('2023/05/28 23:59:59')
    if (nowdate > date1 && nowdate < date2) {
      this.isWeekEndFlag = true
    } else {
      this.isWeekEndFlag = false
    }
    if (this.getMode != 'production') {
      this.isWeekEndFlag = true
    }
  },
  beforeMount: function () {
    if (this.formatData.createDate === null) {
      this.formatData.createDate = this.$formLib.getToday()
    }
    // 履歴書データから自動入力
    this.autoFillFromRirekisho()
    // AI利用回数を取得
    this.fetchAiUsageCount()

    this.$eventHub.$on('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$on('basic-data-changed', this.dataChanged)
    this.$eventHub.$on('format-data-changed', this.dataChanged)
  },
  destroyed: function () {
    this.$eventHub.$off('deactivate-history-item', this.deactivateHistoryItem)
    this.$eventHub.$off('basic-data-changed', this.dataChanged)
    this.$eventHub.$off('format-data-changed', this.dataChanged)
  }
}
</script>
<style scoped lang="scss"></style>
